import { Divider } from "antd";
import "./Security.css";
import PrimaryButton from "components/Buttons/PrimaryButton/PrimaryButton";
import { Form } from "antd";
import Selector from "components/Selector/Selector";
import { useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import centralApi from "services/centralApi";
import Spinner from "components/Spinner/Spinner";
import { t } from "i18next";
import { getToken } from "redux/features/app/authTokenSlice";
import { STRING_BOOLEAN_OPTIONS } from "utils/constants/selectorOptions";
import useMessage from "hooks/useMessage";
import { EDStatusEnum, OnOffEnum, PasswordResetModeEnum } from "utils/enums";
import { API_ENDPOINTS } from "utils/constants";

interface SecurityProps {
  currentAppKey: any;
  updateCurrentAppKey: () => void;
}

const Security= ({
  currentAppKey,
  updateCurrentAppKey,
}:SecurityProps) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const dispatch: any = useDispatch();

  const loginUser = useSelector((state: any) => state.loginUser);
  const activeApp = useSelector((state: any) => state.activeApp);
  const authToken = useSelector((state: any) => state.authToken.token);
  const {showError,showSuccess}=useMessage()
  const appId = activeApp.appId;
  const api_key = loginUser.data.api_key;
  const onFormSubmit = async (values: any) => {
    const payload = {
      args: JSON.stringify({
        app_id: appId,
        ...values,
      }),
      app_id: appId,
      api_key: api_key,
      authToken
    };
    await saveAppAuthState(payload);
    updateCurrentAppKey();
    dispatch(getToken())
  };

  async function saveAppAuthState(formData: any) {
    try {
      setLoading(true);
      await centralApi("POST", API_ENDPOINTS.SAVE_APP_AUTH_STATE_URL, formData, null);
      showSuccess(t("sucessfullySavedLabel"))
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showError(t("somethingWrongLabel"))
    }
  }
  
  useEffect(() => {
    // Set initial form values when currentAppKey changes
    const updatedFormValues = {
      passwordResetMode: currentAppKey[0]?.ResetPassswordMode,
      concurrentLogin: currentAppKey[0]?.concurrentLogin,
      state: currentAppKey[0]?.email_auth,
      auditlog:currentAppKey[0]?.insertAuditLog
    };
    form.setFieldsValue(updatedFormValues);
  }, [currentAppKey, form]);
  return (
    <>
      <div className="security-setting-container">
        <div className="mt-4 mb-4  ">
          <h6 className="security-setting-container-heading">
            {t("securitySettingLabel")}
          </h6>
          <Divider className="security-setting-custom-divider" />
        </div>

        <div className=" col-sm-8 mt-4 mb-4 align-items-center security-setting-form ">
          {loading ? (
            <Spinner />
          ) : (
            <Form form={form} layout="horizontal" onFinish={onFormSubmit}>
              <Form.Item
                label={t("passwordResetModeLabel")}
                name="passwordResetMode"
                rules={[
                  {
                    required: true,
                    message: `${t("plzSelectLabel")}`,
                  },
                ]}
              >
                <Selector
                  options={[
                    {
                      value: PasswordResetModeEnum.SMTP,
                      label: t("smtpLabel"),
                    },
                    {
                      value: PasswordResetModeEnum.ADMIN,
                      label: t("adminLabel"),
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item
                label={t("allowConcurrentLoginLabel")}
                name="concurrentLogin"
                rules={[
                  {
                    required: true,
                    message: `${t("plzSelectLabel")}`,
                  },
                ]}
              >
                <Selector
                  options={[
                    {
                      value: OnOffEnum.ON,
                      label:  t("onLabel"),
                    },
                    {
                      value: OnOffEnum.OFF,
                      label:  t("offLabel"),
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item
                label={t("emailAuthLabel")}
                name="state"
                rules={[
                  {
                    required: true,
                    message: `${t("plzSelectLabel")}`,
                  },
                ]}
              >
                <Selector
                  options={[
                    {
                      value: EDStatusEnum.DISABLE,
                      label: t("disableLabel"),
                    },
                    {
                      value: EDStatusEnum.ENABLE,
                      label: t("enableLabel")
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item
                label={t("insertAuditLogLabel")}
                name="auditlog"
                rules={[
                  {
                    required: true,
                    message: `${t("plzSelectLabel")}`,
                  },
                ]}
              >
                <Selector
                  options={[
                    {
                      value: STRING_BOOLEAN_OPTIONS.TRUE,
                      label:  t("onLabel"),
                    },
                    {
                      value: STRING_BOOLEAN_OPTIONS.FALSE,
                      label:  t("offLabel"),
                    },
                  ]}
                />
              </Form.Item>
              

              <div>
                <PrimaryButton
                  size="middle"
                  type="primary"
                  htmlType="submit"
                >
                  {t("saveLabel")}
                </PrimaryButton>
              </div>
            </Form>
          )}
        </div>
      </div>
    </>
  );
};
export default Security;
